import React from "react";
import { MTableToolbar } from "material-table";

export const EXPORT_ACTION_NAME = "export";

/**
 * Toolbar de material-table que habilita/deshabilita la accion de exportar segun
 * el estado interno de la tabla. material-table le pasa al Toolbar sus propias
 * columnas (con tableData.groupOrder) y la data ya filtrada/buscada.
 */
export function MaterialTableExportToolbar(props) {
    const isGrouped = (props.columns || []).some(
        (column) => column.tableData && column.tableData.groupOrder > -1
    );
    const rows = props.data || [];
    const disabledReason = isGrouped ? "grouped" : rows.length === 0 ? "empty" : null;

    const actions = (props.actions || []).map((action) => {
        if (!action || action.name !== EXPORT_ACTION_NAME) return action;

        if (!disabledReason) {
            return { ...action, onClick: () => action.onClick(rows) };
        }

        return {
            ...action,
            disabled: true,
            tooltip: (action.disabledTooltip || {})[disabledReason] || action.tooltip,
            onClick: () => {},
        };
    });

    return <MTableToolbar {...props} actions={actions} />;
}
